'use strict';

function parallaxFunction(g) {
  function parallaxEffect() {
    var $scrollTop = $(this).scrollTop();
    var $speed = 5;

    $('.parallax-on-scroll').each(function() {
      var $elt = $(this);

      $elt.css({
        'background-position': 'center ' + $scrollTop / $speed +'px'
      });
    });
  };

  function init() {
    parallaxEffect();
    $(window).on('scroll', parallaxEffect);
  }

  init();
}
